export default "__VITE_ASSET__CdHr0SK___"